var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C6 3.34315 7.34315 2 9 2H19C20.6569 2 22 3.34315 22 5V15C22 16.6569 20.6569 18 19 18H18V19C18 20.6569 16.6569 22 15 22H5C3.34315 22 2 20.6569 2 19V9C2 7.34315 3.34315 6 5 6H6V5ZM17.2682 7.03646C16.9322 6.94326 16.557 7.02874 16.2929 7.29289L13 10.5858L11.7071 9.29289C11.3166 8.90237 10.6834 8.90237 10.2929 9.29289C9.90237 9.68342 9.90237 10.3166 10.2929 10.7071L12.2929 12.7071C12.6834 13.0976 13.3166 13.0976 13.7071 12.7071L17.7071 8.70711C17.8047 8.60948 17.878 8.49668 17.9268 8.3763C17.9286 8.37178 17.9304 8.36725 17.9322 8.36271C18.0714 8.00444 17.9963 7.58212 17.7071 7.29289C17.5807 7.16652 17.429 7.08105 17.2682 7.03646ZM16 18H9C7.34315 18 6 16.6569 6 15V8H5C4.44772 8 4 8.44772 4 9V19C4 19.5523 4.44772 20 5 20H15C15.5523 20 16 19.5523 16 19V18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8bb101472f15fdad06a7cf4af8d1d874.svg";
export { ForwardRef as ReactComponent };